<template>
  <div class="model-search-simple">
    <div class="form-group">
      <label for="categories">Category</label>
      <select v-model="category" id="categories" class="form-control">
        <option value="">Select One</option>
        <option v-for="(categoryObj) in categories" :key="categoryObj.id" :value="categoryObj.id">{{ categoryObj.name }}</option>
      </select>
    </div>
    <div v-if="models.length" class="form-group">
      <label for="models">Model</label>
      <select v-model="model" id="models" class="form-control">
        <option value="">Select One</option>
        <option v-for="(modelObj) in models" :key="modelObj.url" :value="modelObj.url">{{ modelObj.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
/* global categories */

export default {
  name: 'ModelSearchSimple',
  data () {
    return {
      categories: categories,
      category: '',
      models: [],
      model: ''
    }
  },
  created: function () {
    this.getModels()
  },
  watch: {
    category: function () {
      this.getModels()
    },
    model: function () {
      this.doRedirect()
    }
  },
  methods: {
    async getModels () {
      var postData = JSON.stringify({ category_id: this.category })
      var rootObj = this

      fetch(
        '/get-models',
        {
          method: 'POST',
          body: postData,
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
      )
        .then(response => response.json())
        .then(function (json) {
          rootObj.models = json.models
          rootObj.model = null
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    },
    doRedirect () {
      if (this.model) {
        window.location = this.model
      }
    }
  }
}
</script>
